import { type SerializedPageStructure } from '@wix/document-services-types'
import { entries } from '@wix/wix-data-client-common-standalone'

import { type DataBindingController } from '../types'
import { assertDataBindingController, modifyComponentByVeloId } from '../utils'
import { ROUTER_DATASET_VELO_ID } from '../veloIds'

export const removeRouterDatasetConnectionsToComponents = ({
  page,
  componentIds,
}: {
  page: SerializedPageStructure
  componentIds: string[]
}) =>
  modifyComponentByVeloId({
    root: page,
    veloId: ROUTER_DATASET_VELO_ID,
    modifyComponent: (routerDataset): DataBindingController => {
      assertDataBindingController(routerDataset)
      return {
        ...routerDataset,
        custom: {
          ...routerDataset.custom,
          relatedConnections: Object.fromEntries(
            entries(routerDataset.custom.relatedConnections).filter(
              ([componentId]) => !componentIds.includes(componentId),
            ),
          ),
        },
      }
    },
  })
